import {
  OpensearchCuratedSearch,
  LinkedinSalesNavigatorFilters,
} from "../../__generated__/graphql";

const SCORING_CRITERIA_MAX_LENGTH = 255;
const SCORING_CRITERIA_MIN_LENGTH = 3;

const hasFiltersApplied = <
  T extends OpensearchCuratedSearch | LinkedinSalesNavigatorFilters,
>({
  filters,
  type = "linkedin" as T extends LinkedinSalesNavigatorFilters
    ? "linkedin"
    : "internal",
}: {
  filters: T | null;
  type?: T extends LinkedinSalesNavigatorFilters ? "linkedin" : "internal";
}) => {
  if (!filters) {
    return false;
  }

  if (type === "linkedin") {
    const linkedinFilters = filters as LinkedinSalesNavigatorFilters;
    return (
      (linkedinFilters.jobTitles?.length ?? 0) > 0 ||
      (linkedinFilters.companyHeadCounts?.length ?? 0) > 0 ||
      (linkedinFilters.companyNames?.length ?? 0) > 0 ||
      (linkedinFilters.industries?.length ?? 0) > 0 ||
      (linkedinFilters.geographies?.length ?? 0) > 0 ||
      (linkedinFilters.companyHQLocations?.length ?? 0) > 0
    );
  }

  const internalFilters = filters as OpensearchCuratedSearch;
  return (
    Boolean(internalFilters.opensearchFiltersBlob) ||
    Boolean(internalFilters.auxiliary_filters?.companyNames?.length) ||
    Boolean(internalFilters.auxiliary_filters?.orgCompanyIds?.length)
  );
};

const getScoringCriteriaErrors = (filters: string[]) =>
  filters.map((filter) => {
    if (!filter.trim()) {
      return "Scoring criteria cannot be empty";
    }
    if (filter.length > SCORING_CRITERIA_MAX_LENGTH) {
      return "Scoring criteria is too long";
    }
    if (filter.trim().length < SCORING_CRITERIA_MIN_LENGTH) {
      return `Scoring criteria must be at least ${SCORING_CRITERIA_MIN_LENGTH} characters`;
    }
    return null;
  });

export { hasFiltersApplied, getScoringCriteriaErrors };
